import Service from "../../Service";
const resource = "SpcDocument/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },

  list(SpcID, requestID) {
    return Service.post(resource + "list", {}, {
      params: { SpcID, requestID },
    });
  },

  save(parameters, requestID) {
    return Service.post(resource + "save", parameters, {
      params: { requestID },
    });
  },

  download(parameters, request) {
    return Service.post(resource + "download", parameters, {
      params: { requestID },
    });
  },
};
